import React from 'react'
import {
  AuthProvider, DisplayModalProvider
} from 'context'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import AppRouter from 'router'

import { ApiConfigurator } from 'utils/api'

import 'dayjs/locale/es'

dayjs.locale('es')
dayjs.extend(utc)

ApiConfigurator()

const App: React.FC = () => {
  return (
    <AuthProvider>
      <DisplayModalProvider>
        <AppRouter />
      </DisplayModalProvider>
    </AuthProvider>
  )
}

export default App
